import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type { Catalogs } from './types';

export function useCatalogs() {
  return useQuery({ queryKey: ['catalogs'], queryFn: () => api<Catalogs>('/api/catalogs'), staleTime: 5 * 60_000 });
}
